export const environment = {
  production: true,
  baseUriBE: 'https://gestionale.elsasrl.com/api/v1/frontend',
  url: 'https://elsasrl.com',
  googleMapsKey: 'AIzaSyCQLOZpLJ4BAsFNY600S-aEhkJRLeTFltY'
};
